<template>
  <div class="InputCaptchaPage">
    <div>
      <div class="title">验证码已发送至</div>
      <div class="infoDiv">
        <!--   验证码发送的手机号脱敏显示   -->
        <div class="phone">{{ phoneFormat }}</div>
        <!--   重新发送倒计时   -->
        <div class="countdown" v-if="currentSeconds > 0">
          {{ currentSeconds }}s
        </div>
        <!--   重新发送按钮，超时显示   -->
        <div class="sendBtn" @click="clickGetCaptcha" v-else>重新发送</div>
      </div>
      <!--  验证码输入框  -->
      <div class="verification-container">
        <div v-for="(item, index) in 4" :key="index">
          <div
            class="verification-input"
            :class="
              index == foucsIndex
                ? 'focus'
                : verificationCode[index]
                ? 'input_left'
                : 'input_right'
            "
            @click="verClick(index)"
          >
            <div class="code">{{ verificationCode[index] }}</div>
            <div class="cur" v-if="index == foucsIndex"></div>
          </div>
        </div>
      </div>
      <!--  数字键盘  -->
      <van-number-keyboard
        :show="showKeyboard"
        v-model="value"
        @input="onInput"
        @delete="onDelete"
      />
    </div>
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
  </div>
</template>

<script>
// 引入API
import * as Http from "@/api/HttpService.js";
export default {
  name: "InputCaptchaPage",
  data() {
    return {
      //键盘是否展示
      showKeyboard: true,
      //输入的验证码，键盘绑定输入
      value: "",
      verificationCode: ["", "", "", ""],
      //光标index,模拟input光标显示
      foucsIndex: 0,
      //倒计时剩余时间 单位s
      currentSeconds: 59,
      //倒计时整体时间设置
      totalSeconds: 59,
      //倒计时
      intervalId: null,
      loading: false,
      phone: "",
      phoneFormat: "",
      channelCode: "",
    };
  },
  watch: {
    verificationCode(value) {
      const filterArr = this.verificationCode.filter((item) => item != "");
      //获取输入值
      let inputValue = "";
      for (const filterArrKey in filterArr) {
        inputValue += filterArr[filterArrKey];
      }
      if (inputValue.length == 4) {
        //隐藏键盘
        this.showKeyboard = false;
        this.foucsIndex = -1;
        //校验验证码
        this.checkCode(inputValue);
      }
    },
  },
  mounted() {
    this.phone = this.$route.params.phone;
    this.phoneFormat = this.$route.params.phone.replace(
      /(\d{3})\d{4}(\d{4})/,
      "$1****$2"
    );
    this.channelCode = this.$route.params.channelCode;
    window.localStorage.setItem("channelCode_AI", this.channelCode);
    //开启倒计时
    this.setCountdown();
  },

  methods: {
    //验证码输入框点击
    verClick(index) {
      this.foucsIndex = index;
      this.showKeyboard = true;
    },
    //输入事件监听
    onInput(value) {
      this.verificationCode.splice(this.foucsIndex, 1, value + "");
      if (this.foucsIndex < 3) {
        this.foucsIndex = this.foucsIndex + 1;
      }
    },
    //删除事件监听
    onDelete() {
      if (this.verificationCode[this.foucsIndex] != "") {
        this.verificationCode.splice(this.foucsIndex, 1, "");
      } else {
        if (this.foucsIndex > 0) {
          this.foucsIndex = this.foucsIndex - 1;
          this.verificationCode.splice(this.foucsIndex, 1, "");
        }
      }
    },
    // 校验验证码
    checkCode: async function (inputValue) {
      this.loading = true;
      //获取验证码后开启倒计时
      // this.setCountdown();
      let params = {
        system: this.channelCode,
        phone: this.phone,
        smsCode: inputValue,
      };
      await Http.SmsLogin(params)
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            // 登录成功
            window.localStorage.setItem(
              "sessionId_AI",
              res.originalData.data.sessionId
            );
            window.localStorage.setItem(
              "appId_AI",
              res.originalData.data.appId
            );
            window.localStorage.setItem(
              "userId_AI",
              res.originalData.data.userId
            );
            // 这个用来区分是否是短信登录的，如果是短信登录进来的，不允许分享
            window.localStorage.setItem("phoneLogin_AI", true);
            window.localStorage.setItem("clientType_AI", "app");
            const thisUserId = res.originalData.data.userId;
            window._czc && window._czc.push(["_setUUid", thisUserId]);
            setTimeout(() => {
              this.$router.replace({
                name: "ChatListPage",
              });
            }, 5);
            this.$router.go(-1);
          } else {
            this.$toast(res.originalData.msg || "网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络异常");
        });
      this.loading = false;
    },
    // 设置倒计时
    setCountdown() {
      this.currentSeconds = this.totalSeconds;
      if (this.intervalId != null) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        if (this.currentSeconds > 0) {
          this.currentSeconds -= 1;
        } else {
          // 倒计时结束
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    // 点击获取验证码
    clickGetCaptcha: async function () {
      this.loading = true;
      let params = {
        system: this.channelCode,
        phone: this.phone,
      };
      await Http.getCaptcha(params)
        .then(({ res }) => {
          this.loading = false;
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            this.$toast("发送成功");
            this.setCountdown();
          } else {
            this.$toast(res.originalData.msg || "网络异常");
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.$toast("网络异常");
        });
    },
  },
};
</script>

<style lang="scss">
@import "./InputCaptchaPage";
</style>
